export interface ScheduledReport {
  createdOn: string
  accountId: string
  accountName ?: string | null
  enabled: boolean
  format: 'CSV' | 'PDF'
  frequency: 'DAILY' | 'WEEKLY' | 'MONTHLY'
  frequencyDayOfMonth: number
  frequencyDayOfWeek: number
  frequencyMonthly: 'FIRST' | 'SECOND' | 'THIRD' | 'FOURTH' | 'LAST' | 'SPECIFIC_DATE'
  frequencyTime: string
  lastModifiedOn: string
  lastRun: string | null
  nextRun: string | null
  recipients: string[]
  relativeDateRange: 'YESTERDAY' | 'TODAY' | 'LAST_3_DAYS' | 'LAST_7_DAYS' | 'LAST_30_DAYS' | 'LAST_60_DAYS' | 'LAST_90_DAYS'
  reportName: string
  reportId: string
  id: string
  zoneId: string
}

export type SchedulePayload = {
  enabled: boolean;
  format: string;
  frequency: string;
  frequencyDayOfMonth?: number;
  frequencyDayOfWeek?: number;
  frequencyMonthly?: string;
  frequencyTime: string;
  relativeDateRange: string;
  reportId: string;
  zoneId: string;
  recipients: string[];
};

export interface ScheduledReportsDrawerType {
  enabled: boolean
  format: 'CSV' | 'PDF'
  frequency: 'DAILY' | 'WEEKLY' | 'MONTHLY'
  frequencyDayOfMonth: number
  frequencyDayOfWeek: number
  frequencyMonthly: 'FIRST' | 'SECOND' | 'THIRD' | 'FOURTH' | 'LAST' | 'SPECIFIC_DATE'
  frequencyTime: string
  isReportNameFixed: boolean
  lastModifiedOn: string
  recipients: string[]
  recipientsError: string
  relativeDateRange: 'YESTERDAY' | 'TODAY' | 'LAST_3_DAYS' | 'LAST_7_DAYS' | 'LAST_30_DAYS' | 'LAST_60_DAYS' | 'LAST_90_DAYS'
  reportName: string
  reportNameError: string
  reportId: string
  zoneId: string
  scheduledId: string
}

export interface ReportNameDropDown {
  reportId: string
  reportName: string
}

export enum FrequencyMonthly {
  first = 'FIRST',
  second = 'SECOND',
  third = 'THIRD',
  fourth = 'FOURTH',
  last = 'LAST',
  specificDate = 'SPECIFIC_DATE'
}

export enum WeekDays {
  su = 'Su',
  mo = 'Mo',
  tu = 'Tu',
  we = 'We',
  th = 'Th',
  fr = 'Fr',
  sa = 'Sa'
}

export enum Frequency {
  daily = 'DAILY',
  weekly = 'WEEKLY',
  monthly = 'MONTHLY'
}

export enum ReportFormat {
  CSV = 'CSV',
  PDF = 'PDF'
}

export enum TimeRange {
  yesterday = 'YESTERDAY',
  today = 'TODAY',
  last3Days = 'LAST_3_DAYS',
  last7Days = 'LAST_7_DAYS',
  last30Days = 'LAST_30_DAYS',
  last60Days = 'LAST_60_DAYS',
  last90Days = 'LAST_90_DAYS'
}
